import { createEvent, createStore, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  CashBooster,
  CashBoosterMonth,
  CashBoosterMonthResponse,
  CashBoosterRequest,
  CashBoosterResponse,
} from './types'
import { isAllElementsOfSearchTextNotExist } from '../../../../libs/utils'
import { changedDateFormat } from '../../../billing/transactions/list/model'
import {
  createBlockPartner,
  updateBlockPartner,
} from '../widgets/blockingModal/model'

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map((item) => {
      if (['year', 'month'].includes(item[0])) {
        return [item[0], Number(item[1])]
      }
      return [item[0], item[1]?.toLowerCase()]
    }),
  )
}

export const cashBoosterMounted = createEvent<CashBoosterRequest>()

export const approveMonthMounted = createEvent<CashBoosterMonth>()

export const changePartnerStatusMounted = createEvent<{
  id: number
  status: string
}>()

export const cashBoosterMonthMounted = createEvent()

export const getCashBooster = fx<CashBoosterRequest, CashBoosterResponse>({
  method: 'GET',
  url: `/promo/cash_booster/partner`,
})

export const getCashBoosterMonth = fx<void, CashBoosterMonthResponse>({
  method: 'GET',
  url: `/promo/cash_booster/month`,
})

export const approveMonth = fx<CashBoosterMonth, void>({
  method: 'POST',
  url: `/promo/cash_booster/month/update`,
})

export const changePartnerStatus = fx<
  {
    status: string
  },
  void
>({
  method: 'PUT',
  url: `/promo/cash_booster/partner/`,
})

export const $cashBooster = restore<CashBooster[]>(
  getCashBooster.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfCashBooster = restore(
  getCashBooster.doneData.map((a) => a.body.total),
  0,
)

export const $cashBoosterMonth = restore<CashBoosterMonth[]>(
  getCashBoosterMonth.doneData.map((a) => a.body.items),
  null,
)

export const $lastCashBoosterParams = createStore<CashBoosterRequest | null>(
  null,
).on(cashBoosterMounted, (_, params) => params)

sample({
  // @ts-ignore
  clock: cashBoosterMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'transactionId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] = [
            'reward',
            'country',
          ].includes(key)
            ? filters[key as keyof typeof filters]
            : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      if (Object.keys(newObj).length) {
        // @ts-ignore
        query['where'] = `${JSON.stringify(newObj)}`
      }
    }

    return {
      query,
    }
  },
  target: getCashBooster,
})

// выполняем запрос на получение данных, если успешно выполнились создание и обновление блокировки
sample({
  // @ts-ignore
  clock: [
    createBlockPartner.done,
    updateBlockPartner.done,
    changePartnerStatus.done,
  ],
  source: $lastCashBoosterParams,
  fn: (params) => {
    if (params) {
      let {
        limit,
        page,
        orderBy,
        orderDirection,
        searchText,
        filters = {},
      } = params

      if (orderDirection === 'descend') {
        orderDirection = '-'
      } else if (orderDirection === 'ascend') {
        orderDirection = ''
      }
      if (orderBy === 'transactionId') {
        orderBy = 'id'
      }
      let query = {
        limit,
        page,
      }

      if (orderBy) {
        // @ts-ignore
        query['order'] = orderDirection + orderBy
      }

      if (filters) {
        //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
        let newObj = Object.keys(filters).reduce((accumulator, key) => {
          if (filters[key as keyof typeof filters] != null) {
            accumulator[key as keyof typeof filters] = [
              'reward',
              'country',
            ].includes(key)
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
          }

          return accumulator
        }, {} as any)

        if (!isAllElementsOfSearchTextNotExist(searchText)) {
          newObj = { ...newObj, ...mapSearchText(searchText) }
        }

        if (Object.keys(newObj).length) {
          // @ts-ignore
          query['where'] = `${JSON.stringify(newObj)}`
        }
      }

      return {
        query,
      }
    }
  },
  target: getCashBooster,
})

sample({
  //@ts-ignore
  clock: cashBoosterMonthMounted,
  target: getCashBoosterMonth,
})

sample({
  clock: approveMonthMounted,
  fn: (data) => {
    return {
      url: `/promo/cash_booster/month/update`,
      body: { ...data },
    }
  },
  target: approveMonth,
})

sample({
  clock: changePartnerStatusMounted,
  fn: ({ id, status }) => {
    return {
      url: `/promo/cash_booster/partner/${id}`,
      body: { status },
    }
  },
  target: changePartnerStatus,
})
